/**
 * Namespaces a user-controlled identifier for use as a property name on an object used as a
 * keyed map.
 *
 * A raw route param or query-string value can name a prototype-chain member — `__proto__`
 * swaps the map's prototype, `constructor` shadows it — rather than adding an entry. The
 * prefix makes those names unrepresentable.
 */
export const mapKey = (id: string): string => `id:${id}`
